<email-layout [showLogo]="false">
  <ng-container header>
    <email-message-header [header]="data.p1" [separator]="false" />
    <email-margin [height]="18" />
  </ng-container>

  <ng-container body>
    <div class="event-reminder-box">
      <div class="section">
        <email-text
          [contents]="data.event_full"
          [bold]="true"
          presetName="paragraph"
          size="large"
        />
        <email-text [contents]="data.timezone" size="medium" color="light" />
      </div>
      <hr />
      <div class="section">
        <email-text
          [contents]="data.interviewers_label"
          [bold]="true"
          presetName="paragraph"
          size="small"
          color="light"
        />
        <email-text
          [contents]="data.interviewers"
          [bold]="true"
          presetName="paragraph"
          size="small"
        />
      </div>
      <hr />
      <div class="section">
        <email-button
          [href]="data.button_link"
          [label]="data.button_text"
          theme="primary"
          [inline]="true"
        />
      </div>
    </div>
  </ng-container>
</email-layout>
